import '@/styles/app.css';
import AppProvider from '@/AppProvider';
import AppRouter from './routes/AppRouter';
import { LicenseInfo } from '@mui/x-license';

LicenseInfo.setLicenseKey(
  '74580b57344ce162d77e19ef17cf6266Tz0xMjgwNjksRT0xODA3NDg3OTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1pbml0aWFsLEtWPTI=',
);

export default function App() {
  return (
    <AppProvider>
      <AppRouter />
    </AppProvider>
  );
}
